
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recursos/[slug]",
      function () {
        return require("private-next-pages/recursos/[slug]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recursos/[slug]"])
      });
    }
  